import styled from '@emotion/styled';
import media from 'css-in-js-media';
import { css } from '@emotion/core';

export const StyledBlogTextContent = styled.div`
  padding-left: 8px;
`;

export const styledFeaturedBlogTitle = css`
  font-family: 'WorkSans-Bold', 'system-ui', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto',
    'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';
  font-size: 32px;
  font-weight: normal;
  background-color: #f4f5f9;
  color: #031b4e !important;
  letter-spacing: -1px;
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: -14px;
  text-align: left;
  position: absolute;
  z-index: 1;
  top: 100px;

  ${media('<tablet')} {
    top: 90px;
    text-align: center;
    align-self: center;
    margin-bottom: 64px;
  }
`;

export const StyledFeaturedBlogContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f4f5f9;
  text-align: left;
  width: 100vw;
  position: relative;
  margin-left: -50vw;
  margin-bottom: -64px;
  padding-bottom: 100px;
  left: 50%;

  .featured-blog-post:first-of-type {
    margin-left: 48px;
  }

  .featured-blog-post:last-of-type {
    margin-right: 48px;
  }

  ${media('<tablet')} {
    .featured-blog-post {
      margin-left: 24px !important;
      margin-right: 24px !important;
    }

    margin-bottom: 32px;
    flex-direction: column;
    align-items: center;

    .first-blog-post {
      margin-top: 180px;
    }
  }
`;

export const StyledBlogListContent = styled.div`
  -webkit-box-shadow: 0px 0px 2px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 2px -1px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 2px -1px rgba(0, 0, 0, 0.75);
  border-radius: 3px;
  width: 360px;
  height: auto;
  background: #fff;
  margin-top: 190px;
  margin-right: 16px;
  margin-left: 16px;
  padding: 16px;

  .featured-image {
    padding: 8px;

    img {
      max-height: 169px;
    }

    ${media('<desktop')} {
      img {
        max-height: 140px;
      }
    }

      ${media('<tablet')} {
        img {
          max-height: 169px;
        }
      }
    }
  }

  .title {
    margin-top: 16px;
  }

  ${media('<tablet')} {
    margin-top: 32px;
    margin-left: 0;
    margin-right: 0;
    height: auto;
    flex-direction: column;
    align-items: center;
    max-width: fit-content;
    padding: 16px;
    background: #fff;
  }
`;
